// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CElM","content":"styles_content__3GK2z"};